import icTech from '../static/images/ic-technology.svg'
import icCre from '../static/images/ic-creative.svg'
import icOpe from '../static/images/ic-operational.svg'

export const dataJobDetail = [
  {
    id: 1,
    title: 'Lead Programmers',
    url: 'lead-programmers',
    description:
      'What are your days like? Every day you will work to create applications and web programs according to company and client needs. You will be working with many IT experts and websites as well as full support of various advanced technology tools. You will work with the application environment and all the strong IT products, demanding rapid development and all factors in the related field. But you will never forget to smile when entering this kind of work environment.   What can you say to your friends, about your work?            Everyone knows about computer programs, websites and apps. Your position is known as the job for intelligent people because it demands strong energy and mind. Not everyone can work like you though very much. So say with pride and smile if you become a Senior Web Programmer.   My responsibilities: Developing a highly-concurrent and distributed system System Performance optimization and problem diagnosis Leading technical team especially backend team Designing/Developing for high-availability Continuously improve code quality, product execution, and learning experience. Analyse requirements, design and develop features Optimize application for maximum performance and scalability Collaborate with fellow developers, product team, user experience team, and operation team to build better products with mobile technologies Help define coding standards and development processes Willing to learn & adapt different technologies',
    requirement:
      "So, what are the requirements? Fast learner & good analytical thinking Good communication skill, team player and comfortable working with cross functional team We work on Nodejs and are open to implement other language, before that you should proficient with NodeJs Experience to build highly concurrent, distributed architectures/ systems Experience with Microservice architecture Having experience with distributed storage and database systems, including SQL or NoSQL Familiar with Linux development environments Familiarity with Deployment on Cloud (AWS, Alibaba Cloud) with Jenkins, Ansible, Consul Familiarity  with SCRUM and Agile method So here you are, you will not be able to enjoy this work if you do not make this important step. What is that? Create your online portfolio and send it to us as soon as possible. Give your best potential and let's join the big family of Halo Jasa team.",
    tag: 'Technology',
    icon: icTech
  },
  {
    id: 2,
    title: 'Senior Programmers',
    url: 'senior-programmers',
    description:
      "My responsibilities: You will develop data to be a product feature whether it's a website or an app. You will devote much effort to create new features, platforms and systems according to client request. At any time you will be involved with the business development team to achieve the goals of a project. You will build a system to prevent bugs, analyze bugs, and keep errors away. You have an important responsibility to keep the working system normally, no big problem and be ready to take responsibility if there is an unexpected fatal problem. Ready to keep a secret about the information of all sensitive projects. Can make code design and write 'clean' code. So, what are the requirements? You should have experience and can working with laravel frame works. You should also master in PHP, jquery, javascript, angular js. Of course we need your ability to work with mysql, rest Api / json / xml. So here you are, you will not be able to enjoy this work if you do not make this important step. What is that? Create your online portfolio and send it to us as soon as possible. Give your best potential and let's join the big family of Halo Jasa team.",
    requirement:
      'Do you have passion in web programming? Are you already working to create a web program? We offer attractive chair to you as a Senior Web Programmer. This job will make you have a career full of challenges, latest technological information and demands to be able to build applications and web according to the client wish. We need your energy and mind to become an expert in the field of web and IT, so please be the first to us. What are your days like? Every day you will work to create applications and web programs according to company and client needs. You will be working with many IT experts and websites as well as full support of various advanced technology tools. You will work with the application environment and all the strong IT products, demanding rapid development and all factors in the related field. But you will never forget to smile when entering this kind of work environment. What can you say to your friends, about your work? Everyone knows about computer programs, websites and apps. Your position is known as the job for intelligent people because it demands strong energy and mind. Not everyone can work like you though very much. So say with pride and smile if you become a Senior Web Programmer.',
    tag: 'Technology',
    icon: icTech
  },
  {
    id: 3,
    title: 'Marketing Strategy',
    url: 'marketing-strategy',
    description:
      'Do you have passion in marketing? Do you really love all areas of marketing? Maybe you also have developed a marketing Strategy  job as a career.              So we are opening the opportunity to everyone who can work in marketing strategy. Of course as part of corporate marketing, you have an important task to deliver our products to consumers and open up potential profits for the company. My responsibilities: Identify and execute on opportunities for community partnership and integration of community programs into marketing initiatives Identify needs, goals, opportunities, and challenges of the business and craft offline and online marketing strategy to achieve business growth goals. Collaborating with cross-functional teams – from creative, IT and production to product marketing and digital marketing – to produce effective promotional materials Develop strategic communications planning for promotion and dissemination of corporate and marketing content to drive brand awareness. Coordinating the design of promotional material for specific marketing campaigns, also responsible for distributing them through the appropriate channels. They research both online and offline channels to learn how to best distribute marketing materials for maximum exposure.',
    requirement:
      "So, what are the requirements? Proven work experience as a Marketing Communications Specialist or similar role a minimum 2 years. Broad knowledge of marketing strategy. Capable of planning, executing, and evaluating marketing strategy. Have a good understanding in the e-commerce industry is point plus Proficient in spoken & written English. Good in terpersonal & communication skill,high initiative,excellent organizational and leadership abilities. So here you are, you will not be able to enjoy this work if you do not make this important step. What is that? Create your online portfolio and send it to us as soon as possible. Give your best potential and let's join the big family of Halo Jasa team.",
    tag: 'Operational',
    icon: icOpe
  },
  {
    id: 4,
    title: 'Dev Ops Engineer',
    url: 'dev-ops',
    description: `Are you interested in becoming a DevOps engineer ?<br />
        Do you have seasoned experience in Amazon Cloud (AWS) using EC2, S3, Code Pipeline, Code Commit, Code Deploy and other related services? If you said yes to any of these questions, we have a great career opportunity for you! We are looking for a Lazy DevOps Engineer to help us build functional systems that improve customer experience.  If you have a solid background in software engineering and are familiar with AWS , Docker or Kubernetes, we'd like to meet you. Ultimately, you will execute and automate operational processes fast, accurately and securely. This job will make you have a full career of challenges<br /><br />
        
        What are your days like?<br />
        If you are lazy person, this is very good position for your career. let the automation do your work. Make automation for everything. Colaborate with Developer team, create tools that can help developer team, deploy the code to the Dev and Production Server, Monitoring and Maintain servers. Build and deploy everything from enterprise technology initiatives to big data and mobile solutions, as well as innovations in ecommerce solutions.<br />
        What can you say to your friends, about your work?<br />  
        So, what are you doing? Say with smile and happy face that you are the most Lazy person in Halojasa. Tell to them if you are the most talented lazy person in our company. You are the most crucial part of this company to ensure service availability for 24/7.
        `,
    requirement: `My responsibilities:<br />
        <ol>
        <li>Support Cloud development pipelines using Jenkins, Gitlab Pipelines, Cloud Formation, Puppet and other tools as appropriate</li>
        <li>Support containerization technologies such as Docker and Kubernetes, other technologies</li> 
        <li>Script and automate system tasks to reduce manual repetitive work using Terraform, Puppet and other technologies as appropriate</li>
        <li>Experience supporting Nodejs applications</li>
        <li>Participate in production software deployments working closely with other members of the production support group to ensure the proper transition of system changes into the production environments</li>
        <li>Perform general technical trouble shooting & give consultation to development teams</li>
        <li>Report issues to management & work to identify root cause of system related issues</li>
        </ol>
        
        Requirements<br />
        So what the requirements :<br />
        <ol>
        <li>This Opportunity only for lazy person, let the automation do your work</li>
        <li>Familiar with CI/CD tools ( Gitlab Pipelines, Jenkins)</li>
        <li>Experience with Firebase are plus</li>
        <li>You are familiar with AWS, Docker and Kubernetes</li>
        <li>You have a strong understanding of distributing system</li>
        <li>You have a familiar with Git</li>
        <li>You are a team player, honest, disciplined, and have great attention to detail</li>`,
    tag: 'Technology',
    icon: icTech
  },
  {
    id: 5,
    title: 'Back End Node Js',
    url: 'back-end-nodejs',
    description: `<b>Are you proficient in  Node Js developer programing ?</b><br /><br />

      The digital world never stops and we follow it. Against this background, Halo Jasa need a Node Js Programmer. Your role will be very important to build all projects related to web start up and all custom web applications. All your tasks require expertise in Node Js programming language. In addition we need your skills to cooperate with design team and willing to learn forward with team.<br /><br />
      
      <b>What are your days like?</b><br /><br />
      
      This is not easy task but very exciting. You can learn about the skills of the  Javascript program. You will also attend the conference to see the progress of the programmer world.  In fact you can work very comfortably with a team that full of passion.<br /><br />
      
      <b>What can you say to your friends, about your work?</b><br /><br />
      
      So, what are you doing? Say with smile and happy face that you are a  Node Js Programmer at Halo Jasa. You work with design team to build and create applications and websites. You also work with team and clients around the world.

      <br /><br /><b>My responsibilities:</b>

      <br/>
      <ul>
      <li>You strive to create new development and feature plans for websites.</li>
      <li>You will work to create a system with the latest dashboard.</li>
      <li>You have both personal business goals and with teams to create a platform that support business.</li>
      <li>You will also work to analyze the problem, test the program and improve the test results if there is a problem.</li>
      <li>You are ready to make a system designed to work smoothly and always provide solutions if there is a problem.</li>
      <li>Utilize backend data services and contribute to increase existing data services API.</li>
      <li>Lead the entire web application development life cycle right from concept stage to delivery and post launch support.</li>
      <li>Convey effectively with all task progress, evaluations, suggestions, schedules along with technical and process issues.</li>
      <li>Document the development process, architecture, and standard components.</li>
      </ul> 
      `,
    requirement: `<b>So, what are the requirements?</b><br/>
      <ul>
      <li>You should be very familiar with javascript Node Js</li>
      <li>Already has experience working with Node JS Framework for min 2 years.</li>
      <li>If you are studying Node Js  program for under 2 year or more, we will consider it.</li>
      <li>Can be open minded to receive suggestions and solutions and have far-sighted thoughts.</li>
      <li>Has the ability to design patterns and workflow,Creative and efficient problem solver</li>
      <li>Have good knowledge about alogritma and Symfony components</li>
      <li>Can Do  using Agile/Scrum process to develop software systems</li>
      </ul>
      <br />
      So here you are, you will not be able to enjoy this work if you do not make this important step. What is that? Create your online portfolio and send it to us as soon as possible. Give your best potential and let's join the big family of Halo Jasa team.
      `,
    tag: 'Technology',
    icon: icTech
  },
  {
    id: 6,
    title: 'Frontend Programmer',
    url: 'frontend-programmer',
    description: `
      <b>Do you have passion in front end programming?</b><br /><br />

      Are you already working to create a web & mobile program? We offer attractive chair to you as front end Programmer. This job will make you have a career full of challenges, latest technological information and demands to be able to build applications and web according to the our project. We need your energy and mind to become front end developer, so please be the first to us.

      <b>What are your days like?</b><br /><br />

      If you’re interested in creating a user-friendly environment by writing code and moving forward in your career, then this job is for you. We expect you to be a tech-savvy profesional, who is curious about new digital technologies and aspires to combine usability with visual design.

      <b>What can you say to your friends, about your work?</b><br /><br />

      Everyone knows about computer programs, websites and apps. Your position is known as the job for intelligent people because it demands strong energy and mind. Not everyone can work like you though very much. So say with pride and smile if you become a front end Programmer.`,
    requirement: `
      <b>My responsibilities:</b><br />

      <ul>
      <li>You will develop data to be a product feature whether it's a website or an app.</li>
      <li>Ensure the technical feasibility of UI/UX</li>
      <li>Write code to implement those visual elements into various web applications</li>
      <li>Optimize websites and applications to ensure fast loading speeds</li>
      <li>Maintain websites and implement any necessary additions or enhancements</li>
      <li>Identify and troubleshoot various website issues and coding problems</li>
      <li>Collaborate with members of the website team (including designers and back-end developers) to consistently</li> 
      <li>improve functionality and user-friendliness of the web applications</li>
      <li>Maintain updated knowledge of the development industry and any advancements in technology</li>
      <li>Meet tight deadlines as required</li>
      <li>Can make code design and write "clean" code.</li>
      </ul>

      <b>So, what are the requirements?</b><br />

      <ul>
      <li>2+ years in a front end development role</li>
      <li>Familiar with UI layouts, Bootstrap, and the CSS GRID system</li>
      <li>Proficient with html5, css3, JavaScript frameworks such as jQuery, Angular et al</li>
      <li>Proficient understanding of cross-browser compatibility issues and ways to work around them.</li>
      <li>Good understanding of SEO principles and ensuring that application will adhere to them.</li>
      </ul>
      <br />
      So here you are, you will not be able to enjoy this work if you do not make this important step. What is that? Create your online portfolio and send it to us as soon as possible. Give your best potential and let's join the big family of Halo Jasa team.
      `,
    tag: 'Technology',
    icon: icTech
  },
  {
    id: 7,
    title: 'Chief Technology Officer',
    url: 'cto',
    description: `
      We are seeking a highly skilled CTO with a storied history in the technological sector. CTO's are tasked with making executive technology decisions on behalf of the company, including managing a technology budget and making investments to align the company with their vision for its technological needs. You should be a strategic thinker, an effective communicator and an expert in technological development.
      <br /><br />
      You will work directly under the CEO and will act as both a technology and business expert, making decisions that will impact the current and future operations of the company.
      <br /><br />
      <b>CTO Responsibilities:</b><br />

      <ul>
      <li>Setting a vision for how technology will be used in the company.</li>
      <li>Ensuring that the technological resources meet the company's short and long-term needs.</li>
      <li>Outline the goals for research and development.</li>
      <li>Creating timelines for the development and deployment of all technological services.</li>
      <li>Making executive decisions on behalf of the company's technological requirements.</li>
      <li>Acting as a mentor to team members.</li>
      <li>Maintaining a consumer-focused outlook and aiding in the delivering of IT projects to market.</li>
      <li>Managing technology budgets and time frames.</li>
      <li>Staying on top of technology trends and developments.</li>
      <li>Ensuring all technology practices adhere to regulatory standards.</li>
      </ul>
      `,
    requirement: `
      <b>So, what are the  CTO requirements:</b><br />

      <ul>
      <li>Masters degree in Computer Science or related field.</li>
      <li>MBA preferred.</li>
      <li>6 years working in a technological role.</li>
      <li>2 years managerial experience.</li>
      <li>Advanced technological skill set and a demonstrated history with technology.</li>
      <li>Exceptional team management skills.</li>
      <li>Excellent verbal and written communication.</li>
      <li>Ability to delegate efficiently.</li>
      <li>Extensive industry knowledge with an eye towards the future.</li>
      </ul> 
      `,
    tag: 'Technology',
    icon: icTech
  },
  {
    id: 8,
    title: 'Product Manager',
    url: 'product-manager',
    description: `
      <b>Are you an expert in product management?</b><br /><br />

      Basically, the company is working to produce products and sell all the products to consumers. All parties in the company will work together in these two areas to achieve financial targets. But all that point will not work if there is no Product Manager. Therefore we need you who have a high passion in arranging cooperation with local partners and distributors to fill this role.
      <br /><br />
      
      <b>What are your days like?</b><br /><br />

      The true meaning of this work is requiring you to be able to negotiate to all clients about the company's products. You will also work to forge a good partnership with all your business partners in order to reach your established target market. You will also do to assessment, research and obtain market information about the product's position. So you can work outside or inside the office and working with various parties.
      <br /><br />
      
      <b>What can you say to your friends, about your work? </b><br /><br />     

      What do you do as Product Manager? Maybe if you imagine your job, this is very complete and complicated. But it's a fun job because you're the foundation of a company to be able to produce and sell products to all regions. So let's just say that you have full responsibility for the company's products.
      <br />
      <b>My responsibilities:</b><br />

      <ul>
      <li>Can represent a company to run a product-related business, negotiate with business partners and communicate to all clients of the company.</li>

      <li>Can manage major business partners and encourage customers to establish cooperation.</li>
      <li>You will conduct research related to old customer and take all new information from the market.</li>
      <li>Can decide the latest product line according to market information and have a way line to realize new ideas.</li>

      <li>Want to compare the company's products with competitor products for analysis purposes.</li>
      <li>Can make a clear source data report about the product for all related fields.</li>
      <li>Build cooperation with sales director for development of product sales strategy.</li>
      <li>Can assess market data by communicating with customers for the purpose of evaluation of sales results.</li>
      <li>Create reports for the benefit of all management areas related to short and long term product sales.</li>
      <li>Willing to review product inventory turnover in accordance with production schedule.</li>
      <li>Want to introduce new products to market in accordance with product requirements filed by clients and product development team.</li>

      <li>Can prepare data analysis of return-on-investment analyses; establishing time schedules with engineering and manufacturing.</li>

      <li>Making preparations for new product introductions and marketing of new products in accordance with production, sales and promotion plans.</li>
      <li>Can make product price estimates according to market research data and review production costs and also profit analysis that can be obtained by the company.</li>
      </ul>
      `,
    requirement: `
      <b>So, what are the requirements?</b><br />

      <ul>
      <li>At least you have a Bachelor's degree in information technology.</li>
      <li>Can communicate very well and act friendly to all people in business line.</li>
      <li>Already knowing the company's business and know to make business development strategies.</li>
      <li>Have a strong analytical way to solve creative problems and skills in business development.</li>
      <li>At least you've been a product manager or related field for 3 years.</li>
      <li>We are eager to cooperate with you who can speak English well, both written or oral.</li>
      </ul>
      <br />
      So here you are, you will not be able to enjoy this work if you do not make this important step. What is that? Create your online portfolio and send it to us as soon as possible. Give your best potential and let's join the big family of Halo Jasa team.
      `,
    tag: 'Operational',
    icon: icOpe
  },
  {
    id: 9,
    title: 'System Analyst',
    url: 'system-analyst',
    description: `
      <b>Do you have passion in information technology system?</b><br /><br />

      Are you happy working to analyst all things related to the IT system? We are need, you who can really work hard to do system analysis. The purpose of your work is to ensure that the requirements of the working system are not affected. You are also ready to provide solutions to all our technological system problems. And your position is actually a System Analyst.
      <br /><br />

      <b>What are your days like?</b><br /><br />

      Every day you will work with computers to perform system analysis that used by the company. You will monitor the IT security system and all other related factors. You will also perform testing for all systems used by companies including web systems. This work will keep you in touch with many teams from various related fields.
      <br /><br />
      
      <b>What can you say to your friends, about your work?</b><br /><br />   

      Actually explaining what you do for this job is not easy. But basically you can give explanation that you make sure all technological systems within the company can work smoothly and good. So it does not take long and tell me that you are a System Analyst.
      <br /><br />
      
      <b>My responsibilities:</b><br />

      <ul>
      <li>You must perform system analysis and create a client business model that requires QA and QC.</li>
      <li>You will work with system analysis, development, and testing teams to ensure technical use of the system and user satisfaction.</li>
      <li>You should be able to make sure your budget and work time targets can be achieved.</li>
      <li>You can draw, create documentation and keep tabs on all test systems.</li>
      <li>Can provide training, materials, documentation of a new system applied.</li>
      <li>Can contribute to the system design.</li>
      </ul>
      `,
    requirement: `
      <b>So, what are the requirements?</b><br />
      <ul>
      <li>We recommend if you have experience in the system requirements field.</li>
      <li>Having a Bachelor degree in computer science, IT and other related fields.</li>
      <li>Already has experience with system intelligence tools.</li>
      <li>Have had experience as a web system analyst for 4 years.</li>
      <li>We also welcome fresh graduates who have high energy and ability.</li>
      <li>Understand the work system in the field of web development such as HTML / CSS, SASS, javascript, jquery, php other framework.</li>
      <li>Understanding database management especially sql server and mysql</li>
      <li>Understanding knowledge in the field of web services API - SOAP / XML, REST / JSON, linux, SSH, BASH scripting - amazon AWS preferred.</li>
      </ul>
      <br />
      So here you are, you will not be able to enjoy this work if you do not make this important step. What is that? Create your online portfolio and send it to us as soon as possible. Give your best potential and let's join the big family of Halo Jasa team.
      `,
    tag: 'Technology',
    icon: icTech
  },
  {
    id: 10,
    title: 'Social Media Strategy',
    url: 'social-media-strategy',
    description: `
      <b>Are you an expert in using social media?</b><br /><br />
      Currently all the latest breakthroughs can be run with social media. There is always a reason why businesses can grow faster with social media. We will also use social media to make our brand widely known. Therefore we need you who can think creatively to use social media. We want you to join as Social Media Strategy.
      <br /><br />
      
      <b>What are your days like?</b><br /><br />
      You know that every second we can find something from social media. You will be part of the team to drive consumers to know the company's brand. Every day you will work with computers or gadgets, connected to the internet, with the aim of operating social media. You will also create ideas or solution so all consumers know who we are.
      <br /><br />
       
      <b>What can you say to your friends, about your work?</b><br /><br />   
      Do you just working to run social media? Some people may ask you that question. But you do not have to regret because your work is very complete. You will run company promotions and introductions to all people. You will work from social media to get the company aim. Let's just say that you work to run social media as Social Media Strategy
      <br /><br />
       
      <b>My responsibilities:</b><br />
      
      <ul>
      <li>You will run a strategy with social media to help promote the company goal.</li>
      <li>You will help the marketing team so can reach marketing target.</li>
      <li>You will create and manage original content for social media companies.</li>
      <li>You are required to maintain a company's social media account and always be able to create fresh new content.</li>
      <li>Join the writers and designers to be able to create interesting content.</li>
      <li>Can work with development teams to promote new corporate products with social media content.</li>
      <li>Can communicate well and be a communicator between the client and the company.</li>
      <li>You can communicate with customers to answer questions, organize live chat sessions with customers and try to get reviews.</li>
      <li>Can create reports on web traffic and ROI for every week and every month.</li>
      <li>Monitor SEO optimization and optimize content according to business.</li>
      <li>Having a soul to create a larger network through social media and active role in the industry.</li>
      <li>Can work with teams to maintain a cohesive social media strategy.</li>
      <li>Understand, follow and can run all social media technology.</li>
      </ul>`,
    requirement: `
      <b>So, what are the requirements?</b><br />

      <ul>
      <li>We recommend you work as Social Media Strategist or social media manager.</li>
      <li>Have experience using social media for brand development.</li>
      <li>Very familiar with SEO tricks and traffic systems on search engines.</li>
      <li>Highly expert to create content based on product identification, corporate and client interests.</li>
      <li>Very proficient with all things related to web site development and design.</li>
      <li>Having proficient multitasking skills.</li>
      <li>Can communicate well both written and verbal.</li> 
      </ul>
      <br />
      So here you are, you will not be able to enjoy this work if you do not make this important step. What is that? Create your online portfolio and send it to us as soon as possible. Give your best potential and let's join the big family of Halo Jasa team.`,
    tag: 'Operational',
    icon: icOpe
  },
  {
    id: 11,
    title: 'System Administrator',
    url: 'system-admin',
    description: `
      <b>Are you interested in System Administrator?</b><br /><br />
      Our companies use many software, hardware and network system details.  At any time these things can get interrupted and must be quickly resolved. Therefore we invite you who can maintain and fix the problem to be able to join as System Administrator expert. Before that make sure that you have the ability to quickly analyze and solve all problems.
      <br /><br />
      
      <b>What are your days like?</b><br /><br />
      Every day you will work to see, maintain and examine our technology infrastructure. You will also connect with many people from different teams in the company. The most definitive part of this job is that you should be able to make sure all the devices are not affected and the work of all users of the device is not hampered.
      <br /><br />
       
      <b>What can you say to your friends, about your work?</b><br /><br />   
      Maybe everyone will think that you work as a computer technician. But that is not right. You can illustrate that your work has a wider scope of work such as networking, hardware and software. Ah, if it is too difficult to explain then say that you become a System Administrator expert.
      <br /><br />
       
      <b>My responsibilities:</b><br />
      
      <ul>
      <li>You should be able to perform procedures on hardware and software including system configuration and install.</li>
      <li>You will manage servers and all technological devices.</li>
      <li>You will manage all accounts and workstations.</li>
      <li>You can work to maintain the system fit to the company's needs.</li>
      <li>You can detect problems, perform analysis and find solutions to all technological system problems.</li>
      <li>You will also check and control all access, firewall and backup.</li>
      <li>You will also make sure all the latest systems and can run the upgrade system.</li>
      <li>You will communicate well to provide training to staff about the latest technology.</li>
      <li>You should be able to create internal wiki with technical documentation, manuals and IT policies.</li>
      </ul>`,
    requirement: `
      <b>So, what are the requirements?</b><br />

      <ul>
      <li>You should have experience working as System Administrator, network administrator and other related fields.</li>
      <li>It is important to work with database, LAN and WAN networks also patch management.</li>
      <li>Have a strong knowledge of security systems such as intrusion detection systems and data backup / recovery.</li>
      <li>Can create scripts in Python, Perl or other language.</li>
      <li>Very important if you can work with various operating systems and platforms.</li>
      <li>Can solve the problem and be open to provide all the information to the related staff.</li>
      <li>We would like to work with you who have Bachelor degree in Information Technology, Computer Science and other related field.</li>
      <li>If you have a profesional certificate such as Microsoft Certified Systems Administrator (MCSA) and other related certificate types then it can be an added value.</li> 
      </ul>
      <br />
      So here you are, you will not be able to enjoy this work if you do not make this important step. What is that? Create your online portfolio and send it to us as soon as possible. Give your best potential and let's join the big family of Halo Jasa team.`,
    tag: 'Operational',
    icon: icOpe
  },
  {
    id: 12,
    title: 'Search Engine Optimize',
    url: 'seo',
    description: `
      <b>Are you an SEO expert?</b><br /><br />
      We will ask again. Are you proficient and master of SEO? We are looking for someone who really understands this field. In accordance with the task, then you will control search engine optimization to support the activities of the company. You must also manage the content according to SEO standards and build key keyword strategies to get into the main search page. Yes, we are looking for a Search Engine Optimization to control all campaigns on Google, Bing, and Yahoo in order to maximize ROI.
      <br /><br />
      
      
      <b>What are your days like?</b><br /><br />
      Every day you will be dealing with the internet and all the things that support SEO activities. You have responsibility for the procurement of content that complies with SEO standards. In addition, this task will also not be separated from keyword analysis that suits the needs of SEO. Essentially you will not work all the way from the internet but you will never get bored.
      <br /><br />
       
      <b>What can you say to your friends, about your work?</b><br /><br />   
      Working as as Search Engine Optimization is difficult to explain. Every day millions people are search for information or online shopping from the internet, but they do not know who is moving behind the scenes. Yes, you are in behind the scenes to support corporate marketing over the internet. So, let's say you're an expert who can analyze products and information over the internet, so that products or services can be known to consumers.
      <br /><br />
       
      <b>My responsibilities:</b><br />
      
      <ul>
      <li>Can analyze data, identify trends and analyze campaigns to achieve ROI results.</li>
      <li>Can track, report web analyze, PPC campaigns and other factors for digital marketing.</li>
      <li>Expert in budget for campaign analysis, monthly cost estimate required and quick prediction of profit.</li>
      <li>Can improve the results of marketing through search engines including for copy pages and organic landing.</li>
      <li>Can work with internet especially for keyword optimization, keyword search and other profit field.</li>
      <li>Can see who the emerging competitors and link analysis of competitors' ads.</li>
      <li>Can do research on search engines and see the potential of optimization.</li>
      <li>Indispensable if you can develop a link strategy.</li>
      <li>Willing to cooperate with the development team for the application of SEO practices.</li>
      <li>Can work with editorial teams for content creation and improve marketing with SEO.</li>
      <li>Can encourage changes for web site, content, links, and other factors according to SEO and keywords.</li>
      </ul>`,
    requirement: `
      <b>So, what are the requirements?</b><br />

      <ul>
      <li>Can analyze data, identify trends and analyze campaigns to achieve ROI results.</li>
      <li>Can track, report web analyze, PPC campaigns and other factors for digital marketing.</li>
      <li>Expert in budget for campaign analysis, monthly cost estimate required and quick prediction of profit.</li>
      <li>Can improve the results of marketing through search engines including for copy pages and organic landing.</li>
      <li>Can work with internet especially for keyword optimization, keyword search and other profit field.</li>
      <li>Can see who the emerging competitors and link analysis of competitors' ads.</li>
      <li>Can do research on search engines and see the potential of optimization.</li>
      <li>Indispensable if you can develop a link strategy.</li>
      <li>Willing to cooperate with the development team for the application of SEO practices.</li>
      <li>Can work with editorial teams for content creation and improve marketing with SEO.</li>
      <li>Can encourage changes for web site, content, links, and other factors according to SEO and keywords</li> 
      </ul>
      <br />
      So here you are, you will not be able to enjoy this work if you do not make this important step. What is that? Create your online portfolio and send it to us as soon as possible. Give your best potential and let's join the big family of Halo Jasa team.`,
    tag: 'Technology',
    icon: icTech
  },
  {
    id: 13,
    title: 'Search Engine Marketing',
    url: 'sem',
    description: `
      <b>Do you enjoy working with the internet?</b><br /><br />
      Currently working in the Internet has become hope and goal. And it is not less important than other professions. If you master of Search Engine Marketing then we invite you to become an expert. This work will keep you connected to the internet, conduct market research, and pay per click (PPC) management.
      <br /><br />
      
      <b>What are your days like?</b><br /><br />
      Every day you will browse all the search engines like Google, Bing, Yahoo and other search engines to manage pay per click marketing. You'll work with SEO and marketing teams to drive traffic and subscribers to a defined channel. You will also manage all marketing campaigns applied to all search engines.<br /><br />
       
      <b>What can you say to your friends, about your work?</b><br /><br />   
      Not many people are familiar with the world of search engine marketing. Because of that rather than your headache explaining to others, it's better to say that you control the company's profits from advertising. Also say that you do promotion and marketing through the internet.
      <br /><br />
       
      <b>My responsibilities:</b><br />
      
      <ul>
      <li>Every day you will analyze data and identify market trends to achieve maximum ROI results in paid campaigns.</li>
      <li>You must analyzing website data, tracking websites and PPC campaigns.</li>
      <li>Manage campaign funds and budgets also estimate monthly funding needs.</li>
      <li>Perform optimizations for copy and landing pages in paid search engines.</li>
      <li>Searching and optimize paid keywords.</li>
      <li>Perform doing research and analysis of competitor's ad links.</li>
      </ul>`,
    requirement: `
      <b>So, what are the requirements?</b><br />

      <ul>
      <li>We need you who already have experience in the field of SEM.</li>
      <li>It's better if you've successfully managed your PPC campaigns on Google, Yahoo and Bing.</li>
      <li>Have an online customer acquisition, conversion and marketing business experience.</li>
      <li>Keep up with the latest trends in search engines and be able to practice well.</li>
      <li>Have experience in bid management tools (e.g., Click Equations, Marin, Kenshoo, Search Ignite).</li>
      <li>Experts with website search engine work systems such as Google Analytics, NetInsight, Omniture, WebTrends).</li>
      <li>Have strong analytical ability and can make SEM report.</li> 
      </ul>
      <br />
      So here you are, you will not be able to enjoy this work if you do not make this important step. What is that? Create your online portfolio and send it to us as soon as possible. Give your best potential and let's join the big family of Halo Jasa team.`,
    tag: 'Technology',
    icon: icTech
  },
  {
    id: 14,
    title: 'Sales Marketing',
    url: 'sales-marketing',
    description: `
      <b>Do you have passion in marketing?</b><br /><br />
      You may have heard "what a business means without marketing". And therefore we also do marketing activities to support the company's business. If you have a passion and a strong desire, then now is the right time to develop with a Sales Marketing career. You will work not only for marketing systems, but also promotions and meet clients from various fields.
      <br /><br />
      
      <b>What are your days like?</b><br /><br />
      Do you think Sales Marketing is scary? You cannot believe it before trying. Every day you will engage with various marketing activities, meet with many clients, promote and perform various marketing strategies. You will also play a role in encouraging the growth and development of the company in terms of profit in every sale.
      <br /><br />
       
      <b>What can you say to your friends, about your work?</b><br /><br />   
      Are you a salesperson? Yes, maybe that is a question that you will get from friends or family. We suggest you to say that you are a Sales Marketing. You work to introduce new products and have a role for the development of the company's business. Your role is huge to keep the company's industry grow up.<br /><br />
       
      <b>My responsibilities:</b><br />
      
      <ul>
      <li>You will communicate with business dealings with clients, potential clients and new potential clients.</li>
      <li>You must introduce products including providing product descriptions and presentations to all clients and prospective clients.</li>
      <li>You are obliged to build a good relationship with all company relations.</li>
      <li>Ready to be able to educate users and application users.</li>
      <li>Can work hard to achieve company target with deadline.</li>
      <li>Can develop market research, competitors and strategies including promotional ideas for each product.</li>
      <li>Can do good sales campaign strategy.</li>
      <li>Willing to telemarketing and follow up costumer.</li>
      </ul>`,
    requirement: `
      <b>So, what are the requirements?</b><br />

      <ul>
      <li>Women who can communicate well, singles and aged between 20-35 years.</li>
      <li>Can work honestly, discipline and have high motivation.</li>
      <li>Very good in using social media.</li>
      <li>Can work with internet and Microsoft office.</li>
      <li>Can work in teams and individuals as well as meticulous.</li>
      <li>Experienced in the field of digital marketing is very important.</li> 
      </ul>
      <br />
      So here you are, you will not be able to enjoy this work if you do not make this important step. What is that? Create your online portfolio and send it to us as soon as possible. Give your best potential and let's join the big family of Halo Jasa team.`,
    tag: 'Operational',
    icon: icOpe
  },
  {
    id: 15,
    title: 'Sales Marketing Manager',
    url: 'sales-marketing-manager',
    description: `
      <b>Do you have passion in marketing?</b><br /><br />
      Do you really love all areas of marketing? Maybe you also have developed a marketing job as a career. So we are opening the opportunity to everyone who can work in marketing as Sales Marketing Manager. Of course as part of corporate marketing, you have an important task to deliver our products to consumers and open up potential profits for the company.
      <br /><br />
      
      <b>What are your days like?</b><br /><br />
      You will meet various clients from various fields to develop the company's product marketing. You will also work with all the company management to manage sales and production so that all products can be accepted by the company. And you will also work hard to manage the company's management so that the company achieves profit targets and sales targets.
      <br /><br />
       
      <b>What can you say to your friends, about your work?</b><br /><br />   
      If anyone asks, are you a product seller? Say it, yes, smiling and feeling proud. All industries will not be able to move without sales and you have an important role for the life of the company. Your position is very important because it controls all marketing, strategy, relationship management and also profit for the company.
      <br /><br />
       
      <b>My responsibilities:</b><br />
      
      <ul>
      <li>You should be able to create marketing strategy ideas and apply those ideas to support the company.</li>
      <li>You can create engaging and creative marketing content that affects consumers</li>
      <li>You must build good communication and business relationships with other business, people, agencies, vendors or other third parties.</li>
      <li>You can make budget estimates and allocate funds wisely and achieve company targets.</li>
      <li>You can create marketing campaign reports, share insights with companies and others also have the right marketing goals.</li>
      </ul>`,
    requirement: `
      <b>So, what are the requirements?</b><br />

      <ul>
      <li>We recommend that you have a Bachelor or Master degree from marketing or other related field.</li>
      <li>Very needed who are experienced in the field of marketing and have the attitude to want to learn.</li>
      <li>Have experience proving that you can design your campaign through various channels.</li>
      <li>Have knowledge and experience about web analytics tools like Google Analytics, NetInsight, Omniture, WebTrends, etc.</li>
      <li>Have experience in setting up and optimizing Google Adwords campaigns.</li>
      <li>Can communicate intelligently and fun.</li>
      <li>Have up-to-date marketing knowledge and follow every new trend emerging.</li> 
      </ul>
      <br />
      So here you are, you will not be able to enjoy this work if you do not make this important step. What is that? Create your online portfolio and send it to us as soon as possible. Give your best potential and let's join the big family of Halo Jasa team.`,
    tag: 'Operational',
    icon: icOpe
  },
  {
    id: 16,
    title: 'Quality Asurance',
    url: 'qa',
    description: `
      <b>Do you have passion in Quality Assurance?</b><br /><br />
      A company will issue the product only when the product has passed the test. Quality assurance will be a priority for all businesses. Therefore we will also do the same and more detail to ensure consumers receives the most perfect products as per quality standards. Therefore we would like to meet with you who can ensure that all our products have a special standard before reaching consumers. We look forward to your arrival as a Quality Assurance engineer.
      <br /><br />
      
      <b>What are your days like?</b><br /><br />
      Basically, every day you already have a program to check all the products passed in the quality assessment standards in accordance with company policy. You should also find some potential product failures and product problems. After that, you should also be able to find solutions and design tests that are most appropriate for the product so that consumers only accept good quality products.
      <br /><br />
       
      <b>What can you say to your friends, about your work?</b><br /><br />   
      This is not a strange job and basically all businesses use Quality Assurance to ensure their products. We want you to talk that all our products have been tested and passed in quality standards. And you have an important role to determine all the tests and solutions for our products.
      <br /><br />
       
      <b>My responsibilities:</b><br />
      
      <ul>
      <li>You have a role to check all the specification documents, technical design and all points for product quality assessment.</li>
      <li>You should also be able to make tests, test materials, test cases and complain against the product.</li>
      <li>You can plan test time, test schedule standard, plan and coordinate in test execution.</li>
      <li>You are willing to use open source tools to develop and assess automated test scripts.</li>
      <li>You can track bugs, identify problems, record problems and document all the problems with the product.</li>
      <li>You can pass regression testing to resolved bugs.</li>
      <li>You want and can set up a testing process for new products and old products.</li>
      <li>You can work with product development management teams and production managers to identify problems with products and systems.</li>
      <li>You must slaughter any debugging process.</li>
      <li>You can find solutions for all non-compliant software and implement the solution.</li>
      <li>You can track quality assurance metrics including for the number of defects and other assessments.</li>
      <li>You can work with all the up-to-date testing tools and can implement new test strategies.</li>
      </ul>`,
    requirement: `
      <b>So, what are the requirements?</b><br />

      <ul>
      <li>You have a role to check all the specification documents, technical design and all points for product quality assessment.</li> 
      <li>You should also be able to make tests, test materials, test cases and complain against the product.</li> 
      <li>You can plan test time, test schedule standard, plan and coordinate in test execution.</li> 
      <li>You are willing to use open source tools to develop and assess automated test scripts.</li> 
      <li>You can track bugs, identify problems, record problems and document all the problems with the product.</li> 
      <li>You can pass regression testing to resolved bugs.</li> 
      <li>You want and can set up a testing process for new products and old products.</li> 
      <li>You can work with product development management teams and production managers to identify problems with products and systems.</li> 
      <li>You must slaughter any debugging process.</li> 
      <li>You can find solutions for all non-compliant software and implement the solution.</li> 
      <li>You can track quality assurance metrics including for the number of defects and other assessments.</li> 
      <li>You can work with all the up-to-date testing tools and can implement new test strategies.</li> 
      </ul>
      <br />
      So here you are, you will not be able to enjoy this work if you do not make this important step. What is that? Create your online portfolio and send it to us as soon as possible. Give your best potential and let's join the big family of Halo Jasa team.`,
    tag: 'Technology',
    icon: icTech
  },
  {
    id: 17,
    title: 'Quality Control',
    url: 'qc',
    description: `
      <b>Do you have passion in Quality Control?</b><br /><br />

      Can you make decisions for products and services that are appropriate for clients? This task requires high dedication especially related to product quality. As a Quality Control, you have an obligation to keep the product or service that reaches the consumer completely according to the quality standard of the company. If you want to work to ensure products and services are appropriate for consumers, then we have a Quality Control position for you.
      <br /><br />
      
      
      <b>What are your days like?</b><br /><br />
      Basically, every day you will work according to testing and inspection standards set by the company. You will meet with production management or business management to explain the quality products. You can also specify steps to maintain the quality of your product or service, including finding solutions to problems or consumer claims.
      <br /><br />
       
      <b>What can you say to your friends, about your work?</b><br /><br />   
      
      Do you check the products or services? Maybe that is a question of all your friends and family. But, you do not need be embarrassed because all this work is important to the company. Without your position there is no product or service that can reach to the consumer in high-quality conditions and standards. So do not hesitate to say you're a person in charge of Quality Control.
      <br /><br />
       
      <b>My responsibilities:</b><br />
      
      <ul>
      <li>Willing to run the company procedures for testing raw materials until the final product.</li>
      <li>Can work consistently to follow the standard quality control that has been established company.</li>
      <li>Can analyze products that do not fit the standards, look for causes of damage and find the right solution.</li>
      <li>Can perform percentage analysis for all industrial products.</li>
      <li>Can communicate well to all management, especially when there are problems related to product quality.</li>
      <li>Ensure all products have been feasible quality test and encourage all parties to perform the obligation to maintain the quality.</li>
      <li>Can share knowledge, training and support to all QA teams.</li>
      <li>Can make effective material test for all products.</li>
      </ul>`,
    requirement: `
      <b>So, what are the requirements?</b><br />

      <ul>
      <li>Better if you have experience in quality control field for 4 years.</li>
      <li>If you have been a QC supervisor for at least 2 years then you are strongly considered.</li>
      <li>Can work closely, think analytically and be able to cooperate with all related line in industry.</li>
      <li>Have ability to explain theory and skill to others.</li>
      <li>Having industry certification or related field will be an added value.</li> 
      </ul>
      <br />
      So here you are, you will not be able to enjoy this work if you do not make this important step. What is that? Create your online portfolio and send it to us as soon as possible. Give your best potential and let's join the big family of Halo Jasa team.`,
    tag: 'Technology',
    icon: icTech
  },
  {
    id: 18,
    title: 'Public Relations',
    url: 'pr',
    description: `
      <b>Can you give positive energy to the company?</b><br /><br />

      Talking about a business where you grow is not easy. But we sure can find you who have the soul of communication and development of a good corporate image. We need you who can do a lot of work to talk, spread the business profesionally and actively in the media field. Yes, we are looking for you who do have soul as Public Relation
      <br /><br />
      
      <b>What are your days like?</b><br /><br />
      Basically this task is very fun. You will meet many people from other business and media. You have the opportunity to develop in marketing, business strategy and management. You will negotiate what the company does for the client. And you will be more pleased to be able to meet and communicate directly with various online and offline media including with presentations
      <br /><br />
       
      <b>What can you say to your friends, about your work?</b><br /><br />   
      
      You may indeed be a cheerful person and can provide positive energy in every environment. So you need not hesitate to answer that you are part of Public Relations at Halo Jasa. You will meet people from various fields to convey messages about business and corporate benefits. You work as a representative of a company to participate in building a business
      <br /><br />
       
      <b>My responsibilities:</b><br />
      
      <ul>
      <li>You should be able to give a positive image when communicating whether it is for the purpose of a marketing or promotional strategy.</li>
      <li>You can be a corporate communications center developed by media, printed media, and social media.</li>
      <li>You become a useful link for the community and the company.</li>
      <li>You are also a social media team so that business is increasingly recognized by people.</li>
      <li>You should maintain contact with all media and develop new contacts with all business and media parties.</li>
      <li>You are responsible for answering all media inquiries and interview requests from other media and business sources.</li>
      <li>You should also prepare all presentation materials, articles and news related to the business of the company.</li>
      </ul>`,
    requirement: `
      <b>So, what are the requirements?</b><br />

      <ul>
      <li>You should have experience in related to the media and the wider community.</li> 
      <li>You have the ability to cooperate and create a draft campaign including with national and international relations.</li> 
      <li>You already have a strong relationship with local and national business media.</li> 
      <li>You can communicate well especially to represent the company</li> 
      <li>You should have interesting, polite and intelligent behavior.</li> 
      <li>You have good editing and writing skills, both in Indonesian or English.</li> 
      <li>You are proficient and active to using social media such as blog, Facebook, Twitter, Instagram etc.</li> 
      <li>Highly considered if you have a bachelor's degree in marketing, advertising, marketing, public relations or other related fields</li> 
      </ul>
      <br />
      So here you are, you will not be able to enjoy this work if you do not make this important step. What is that? Create your online portfolio and send it to us as soon as possible. Give your best potential and let's join the big family of Halo Jasa team.`,
    tag: 'Operational',
    icon: icOpe
  },
  {
    id: 19,
    title: 'Operational Manager',
    url: 'operational-manager',
    description: `
      <b>Acting as the Operational Manager for Halo Jasa, you will:</b><br /><br />

      Do you have the power to create strategies and methods in management field? If you are confident in this field, we have a seat for you as Operational Manager. This position will keep you in business on various levels. You will be involved with various jobs including with management team, management training, and all areas of management in the company. You should also be able to improve the four important points of the company: performance, productivity, efficiency and profitability.
      <br /><br />
      
      <b>What are your days like?</b><br /><br />
      Your day will be very busy and fun. You will form a management team, supervise, and control all the work according to the strategies and methods that have been approved by the company. You will also be involved with in various fields including such as corporate financial data, business relationships with clients and all areas of management. Although you will be very busy but your role is very important to the company.
      <br /><br />
       
      <b>What can you say to your friends, about your work?</b><br /><br />   
      
      Actually, if you see all your work result is very important. But, how to explain your position to others and family.  You do not have to feel difficult and just say that you control the running of a company's management so that the business of the company can go on.
      <br /><br />
       
      <b>My responsibilities:</b><br />
      
      <ul>
      <li>You must ensure that all of the company's management systems is working, timely and supportive manner.</li>
      <li>You should also achieve realistic corporate objectives including for company operations.</li>
      <li>You can check all the financial data of the company, analyze the profits and keep the money running good.</li>
      <li>You have the potential and the power to be able to attract and supervise human resources for the company.</li>
      <li>You can give attention to all clients well.</li>
      </ul>`,
    requirement: `
      <b>So, what are the requirements?</b><br />

      <ul>
      <li>We recommend that you have experience in the field of operational managers.</li>
      <li>You already understand about the organization's working system and operations management.</li>
      <li>You have strong experience of assessing company budgets.</li>
      <li>You are already experienced in business and finance.</li>
      <li>You can work with a variety of basic computer science skills including databases, MS Office, etc.</li>
      <li>You have good and strong communication skills at any levels of the company's human resources.</li>
      <li>You have a good leadership and organizational skills.</li>
      <li>You should have passed college in management or related sciences.</li> 
      </ul>
      <br />
      So here you are, you will not be able to enjoy this work if you do not make this important step. What is that? Create your online portfolio and send it to us as soon as possible. Give your best potential and let's join the big family of Halo Jasa team.`,
    tag: 'Operational',
    icon: icOpe
  },
  {
    id: 20,
    title: 'Motion Graphic',
    url: 'motion-graphic',
    description: `
      <b>Acting as the Motion Graphic for Halo Jasa, you will:</b><br /><br />

      Have you ever seen an animation product with some interesting gestures and graphic content? Yes, we are looking for people who can create graphic content as Motion Graphic. To get this job you have to be very creative. You will also be in touch with the design team to produce creative products. The results of your product will be used for various media interests, including such as smartphones, tablets and websites.
      <br /><br />
      
      <b>What are your days like?</b><br /><br />
      You will do all job with fun and great feeling. All teams will support each other for work activities. You will continue to develop mobile application programs, maintain and maintain their functions. You will also meeting with people who skilled in this field.
      <br /><br />
       
      <b>What can you say to your friends, about your work?</b><br /><br />   
      
      If anyone asks then say that your job is very cool. Ask the person again, are they using a mobile app? Yes, then explain that your work is making the app for everyone. You can develop an app idea, create an app and make it work like the original idea.
      <br /><br />
       
      <b>My responsibilities:</b><br />
      
      <ul>
      <li>You are making ideas and create animations that can be used for smartphones, tablets and the web.</li>
      <li>You will work with the illustrator to understand the needs in any animation project.</li>
      <li>You can create animated storyboard for presentation</li>
      <li>You will create a layout concept for all motion graphics projects.</li>
      <li>You will work with all team members to discuss ideas and realize every new idea in each project.</li>
      <li>You will make generate code, change and edit video and add effects or elements to all motion graphics products.</li>
      </ul>`,
    requirement: `
      <b>So, what are the requirements?</b><br />

      <ul>
      <li>You should be able to communicate well and can talk strongly about the concept of ideas.</li> 
      <li>You can enjoy all the work challenges associated with visual design.</li> 
      <li>You can solve all the creative problems design.</li> 
      <li>You can manage the time to work according to the target time.</li> 
      <li>You can work independently to monitor project outcomes and review the work well.</li> 
      <li>You can work individually and team.</li> 
      </ul>
      <br />
      So here you are, you will not be able to enjoy this work if you do not make this important step. What is that? Create your online portfolio and send it to us as soon as possible. Give your best potential and let's join the big family of Halo Jasa team.`,
    tag: 'Creative',
    icon: icCre
  },
  {
    id: 21,
    title: 'Mobile Programmer (React Native/Hybrid Apps)',
    url: 'mobile-progammer',
    description: `
      <b>As the Mobile Programmer for Halo Jasa, you will:</b><br /><br />

      The world cannot be fooled that all things can work very fast just from your gadget. The mobile app has made it easy for all jobs and businesses. And Halo Jasa supports all these developments. Therefore we want to meet with people who can become Mobile Programmer. This job has a comfortable yet highly competitive job environment. You should also work with engineering team to create mobile application program, manage mobile application and all work related to mobile platform.
      <br /><br />
      
      <b>What are your days like?</b><br /><br />
      You will do all job with fun and great feeling. All teams will support each other for work activities. You will continue to develop mobile application programs, maintain and maintain their functions. You will also meeting with people who skilled in this field.
      <br /><br />
       
      <b>What can you say to your friends, about your work?</b><br /><br />   
      
      If anyone asks then say that your job is very cool. Ask the person again, are they using a mobile app? Yes, then explain that your work is making the app for everyone. You can develop an app idea, create an app and make it work like the original idea.
      <br /><br />
       
      <b>My responsibilities:</b><br />
      
      <ul>
      <li>Design, develop, test, deploy, support and evolve software (react native / hybrid applications, API’s)</li>
      <li>You will work with the team to determine the program, design and create the latest app features.</li>
      <li>You should also work with various outside sources and APIs</li>
      <li>You should be able to design a code robustness test to determine potential problems and common functions.</li>
      <li>You can work to fix all bugs in the app and find ways to keep them from happening.</li>
      <li>You will work with the latest technology to check and maximize mobile app design.</li>
      </ul>`,
    requirement: `
      <b>So, what are the requirements?</b><br />

      <ul>
      <li>You should have BS/MS degree in IT or computer engineering or related subject.</li>
      <li>Greatly understand the work process of Android and iOS hybrid.</li>
      <li>Understand the knowledge of mobile, mobile application design and all the technology in this field.</li>
      <li>Minimum 1 years of cumulative mobile app development, design, and/or architecture experience with any of the following areas</li>
      <li>Server-side/Middleware (REST API services, microservices, Node.js, Apigee)</li>
      <li>Minimum 1 year of experience troubleshooting, diagnosing, prototyping, gathering requirements or supporting mobile app development as part of a team</li>
      <li>Minimum of a Bachelor’s degree</li> 
      </ul>
      <br />
      So here you are, you will not be able to enjoy this work if you do not make this important step. What is that? Create your online portfolio and send it to us as soon as possible. Give your best potential and let's join the big family of Halo Jasa team.`,
    tag: 'Technology',
    icon: icTech
  },
  {
    id: 22,
    title: 'Laravel Programmer',
    url: 'laravel-progammer',
    description: `<b>
      Are you proficient in php  Laravel developer programing?</b><br /><br />

      The digital world never stops and we follow it. Against this background, Halo Jasa need a Laravel Programmer. Your role will be very important to build all projects related to web start up and all custom web applications. All your tasks require expertise in PHP programming language. In addition we need your skills to cooperate with design team and willing to learn forward with team.
      <br /><br />
      
      <b>What are your days like?</b><br /><br />
      This is not easy task but very exciting. You can learn about the skills of the Laravel program. You will also attend the conference to see the progress of the programmer world.  In fact you can work very comfortably with a team that full of passion.
      <br /><br />
       
      
      <b>What can you say to your friends, about your work?</b><br /><br />   
      
      So, what are you doing? Say with smile and happy face that you are a php Laravel Programmer at Halo Jasa. You work with design team to build and create applications and websites. You also work with team and clients around the world.
      <br /><br />
       
      <b>My responsibilities:</b><br />
      
      <ul>
      <li>You strive to create new development and feature plans for websites.</li>
      <li>You will work to create a system with the latest dashboard.</li>
      <li>You have both personal business goals and with teams to create a platform that support business.</li>
      <li>You will also work to analyze the problem, test the program and improve the test results if there is a problem.</li>
      <li>You are ready to make a system designed to work smoothly and always provide solutions if there is a problem.</li>
      <li>Utilize backend data services and contribute to increase existing data services API.</li>
      <li>Lead the entire web application development life cycle right from concept stage to delivery and post launch support.</li>
      <li>Convey effectively with all task progress, evaluations, suggestions, schedules along with technical and process issues.</li>
      <li>Document the development process, architecture, and standard components.</li>
      </ul>`,
    requirement: `
      <b>So, what are the requirements?</b><br />

      <ul>
      <li>You should be very familiar with PHP.</li>
      <li>Understanding of MVC design patterns.</li>
      <li>Already has experience working with Laravel 5 PHP Framework for min 2 years.</li>
      <li>If you are studying Laravel program for under 1 year or more, we will consider it.</li>
      <li>Already accustomed to working with SQL schema.</li>
      <li>Can be open minded to receive suggestions and solutions and have far-sighted thoughts.</li>
      <li>Has the ability to design patterns and workflow,Creative and efficient problem solver</li>
      <li>Have good knowledge about alogritma and Symfony components</li>
      <li>Can understand REST API design and can work with other PHP framework.</li>
      <li>Can do testing for (PHPUnit, PHPSpec, Behat).</li>
      <li>Can do query optimization and MySQL.</li> 
      </ul>
      <br />
      So here you are, you will not be able to enjoy this work if you do not make this important step. What is that? Create your online portfolio and send it to us as soon as possible. Give your best potential and let's join the big family of Halo Jasa team.`,
    tag: 'Technology',
    icon: icTech
  },
  {
    id: 23,
    title: 'Design Illustrator',
    url: 'design-illustrator',
    description: `
      <b>Do you enjoy working at home or studio?</b><br /><br />

      Now the days are very advanced, where some work does not require you to come to the office. In fact you can work better from home and manage all your own work. If this is your goal, then we offer you to be Design Illustrator. Of course because of your work as an image design then you should be able to provide quality drawing design for various visual products.<br /><br />
      
      <b>What are your days like?</b><br /><br />
      
      We give you the time to enjoy coffee and cake in the morning. But besides that you should also be able to provide design drawings in accordance with the wishes of the client. You can be free to seek inspiration and work anytime, but most importantly your drawing design should be completed on time. So first, imagine this job is very interesting for you.
      <br /><br />
       
      
      <b>What can you say to your friends, about your work?</b><br /><br />   
      
      If anyone asks, what are you doing? Say that you are producing works of art with great ideas and full of motivation. Your product images and illustrations can be found in various print and visual products. Yes, there is no other more appropriate word than you are the Design Illustrator team at Halo Jasa.
      <br /><br />
       
      <b>My responsibilities:</b><br />
      
      <ul>
      <li>You should be able to find unique, original and related ideas to the client wishes.</li>
      <li>You should be able to work with several parties including authors, editors and designers.</li>
      <li>You can also deal with contractual arrangements with clients.</li>
      <li>You are ready to sketch the image to get supervision from the client.</li>
      <li>You can create final illustrations for all design products.</li>
      <li>You should be able to do business activities for business including promotions.</li>
      </ul>`,
    requirement: `
      <b>So, what are the requirements?</b><br />

      <ul>
      <li>Of course to do this creative work you need to be able to have unique and original ideas and concepts.</li>
      <li>You should also be able to sketch for early promotion.</li>
      <li>You can create original sketches and illustrations.</li>
      <li>If there is a problem about design then you should also find the solution.</li>
      <li>It's important to be able to work creatively to create a strong, sketching, drawing and to follow what the client expects.</li>
      <li>Greatly needed computer skills for design work such as Adobe Suite: Illustrator ,Photoshop an InDesign</li>
      <li>It's better to work with a Mac or PC.</li>
      </ul>
      <br />
      So here you are, you will not be able to enjoy this work if you do not make this important step. What is that? Create your online portfolio and send it to us as soon as possible. Give your best potential and let's join the big family of Halo Jasa team.`,
    tag: 'Creative',
    icon: icCre
  },
  {
    id: 24,
    title: 'Digital Marketing',
    url: 'digital-marketing',
    description: `
      <b>Do you have passion in marketing?</b><br /><br />

      You should know that all business refers to the digital line. This means that all points in the business can be done digitally. Include is also the marketing system with the concept of technology. Therefore Halo Jasa will also develop digital marketing to serve all clients who need products and services. So, if you master all the science and techniques in Digital Marketing, we really hope you can join Halo Jasa.
      <br /><br />
      
      <b>What are your days like?</b><br /><br />
      
      Your important task is to provide support for the promotion and development of products and services digitally. You can also develop every idea and all the promotion based on work online for the company's progress. You will enjoy all the work related to market research, promoting and recognizing competitors in the digital market.
      <br /><br />
       
      
      <b>What can you say to your friends, about your work?</b><br /><br />   
      
      Please do not be angry if others assume that your job is just like regular sales. No, it's not like that, your job as digital marketing in Halo Jasa. You are great because make your company to get clients, you are create powerful digital marketing ideas and you're also researching digital market conditions.
      <br /><br />
       
      <b>My responsibilities:</b><br />
      
      <ul>
      <li>You have to manage an online marketing system that refers to digital marketing.</li>
      <li>It's important to design an online marketing and promotion strategy.</li>
      <li>You are ready to participate in all company activities related to digital marketing system.</li>
      <li>Understand the work of implementing SEM and SEO to manage online and digital marketing.</li>
      <li>You are also ready to be able to conduct market surveys and research to implement promotions for the company products and services.</li>
      <li>It is desirable to be able to perform such digital campaign through social media, advertising tools,newsletter,sms blast,</li>
      <li>You must submit a report on the results of digital marketing and evaluate the evolving trends according to company goals (ROI and KPI).</li>
      <li>You must provide data about market research, market conditions and competitor data.</li>
      <li>You can evaluate every new technology to keep the company grow.</li>
      </ul>`,
    requirement: `
      <b>So, what are the requirements?</b><br />

      <ul>
      <li>You have to manage an online marketing system that refers to digital marketing.</li>
      <li>It's important to design an online marketing and promotion strategy.</li>
      <li>You are ready to participate in all company activities related to digital marketing system.</li>
      <li>Understand the work of implementing SEM and SEO to manage online and digital marketing.</li>
      <li>You are also ready to be able to conduct market surveys and research to implement promotions for the company products and services.</li>
      <li>It is desirable to be able to perform such digital campaign through social media, advertising tools,newsletter,sms blast,</li>
      <li>You must submit a report on the results of digital marketing and evaluate the evolving trends according to company goals (ROI and KPI).</li>
      <li>You must provide data about market research, market conditions and competitor data.</li>
      <li>You can evaluate every new technology to keep the company grow</li>
      </ul>
      <br />
      So here you are, you will not be able to enjoy this work if you do not make this important step. What is that? Create your online portfolio and send it to us as soon as possible. Give your best potential and let's join the big family of Halo Jasa team.`,
    tag: 'Operational',
    icon: icOpe
  },
  {
    id: 25,
    title: 'Content Specialist',
    url: 'content-specialist',
    description: `
      <b>Do you like creating content?</b></br /><br />
      We're looking for an experienced Content Specialist to join our team.

      The successful candidate will have proven experience in producing creative, 
      engaging content and be a versatile writer, adapting to a range of writing styles, topics and client objectives.

      <br /><br />
      <b>Digital knowledge is essential.</b><br /><br />
      We need someone who understands how content can be used to acquire links naturally, 
      boost rankings, increase brand awareness, and other KPIs as part of a wider SEO and digital strategy.
      <br /><br />
      
      <b>Your key responsibilities will include</b><br />
      
      <ul>
      <li>Producing and managing engaging, persona-based content with key objectives in mind - from raising awareness of the brand in new territories to converting leads - across a variety of media types.</li>
      <li>Briefing of content to fellow team members, digital team, design partners and 3rd party authors; ensuring outstanding delivery of assets from all.</li>
      <li>Publishing online documentation for the use of user and also develop content for Customer service policies and procedures</li>
      <li>Assist with and enable all content marketing initiatives to drive traffic, engagement and revenue, delivering to business and marketing objectives.</li>
      <li>Integration of content programs with brand campaigns and product launches.</li>
      <li>Collaborate across functions to deliver against an effective content marketing strategy and editorial plan to meet the business and marketing objectives in the most efficient way.</li>
      </ul>`,
    requirement: `
      <b>To be successful you will need:</b><br />

      <ul>
      <li>Proven experience as a Content Executive, Content Strategist, Content Manager, Writer, or Journalist</li>
      <li>Copywriting and understanding of customers' viewpoints - writing content based on personas</li>
      <li>Knowledge of Content Management Systems (Sitecore an advantage)</li>
      <li>Have experiance for creating and manage content procedure for website and mobile application</li>
      <li>Have at least 2 years work experiance in writing or in same industry</li>
      <li>Be able to originate ideas for engaging content and see them through to completion</li>
      <li>Ability to interview/work with internal and client stakeholders</li>
      <li>Strong working knowledge of content marketing best practice</li>
      <li>Strong working knowledge of digital strategy and SEO</li>
      <li>Experience using social media for business</li>
      </ul>
      <br />
      So here you are, you will not be able to enjoy this work if you do not make this important step. What is that? Create your online portfolio and send it to us as soon as possible. Give your best potential and let's join the big family of Halo Jasa team.`,
    tag: 'Creative',
    icon: icCre
  },
  {
    id: 26,
    title: 'Data Analyst Specialist',
    url: 'data-analyst-specialist',
    description: ``,
    requirement: `
      <b>So, what are the requirements?</b><br />

      <ul>
      <li>You must work using statistical techniques to analyze all data and provide reports on related business points.</li>
      <li>You can work by using a database, collecting all data, analyzing data and other data for company performance technically and statistically.</li>
      <li>You can search for data sources from databases or data systems for both primary and secondary data.</li>
      <li>In general you should be able to analyze and find trends for the company's business only sourced from the data.</li>
      <li>You are not only analyze data but also clean data and monitor data sourced from computer and printed reports to find the source of company problems.</li>
      <li>You must provide the information and data needed for the company's business interests.</li>
      <li>You also have the opportunity to find new data improvement and analysis opportunities for the company.</li>
      </ul>
      <br />
      So here you are, you will not be able to enjoy this work if you do not make this important step. What is that? Create your online portfolio and send it to us as soon as possible. Give your best potential and let's join the big family of Halo Jasa team.`,
    tag: 'Technology',
    icon: icTech
  },
  {
    id: 27,
    title: 'Business Analyst',
    url: 'business-analyst',
    description: ``,
    requirement: `
      <b>So, what are the requirements?</b><br />

      <ul>
      <li>Highly prioritized if having experience in business for 1 - 2 years.</li>
      <li>Accustomed to drawing conclusions and analyzing data related to business, technical and visual data.</li>
      <li>You can communicate well, including oral and written and important to have technical writing skills.</li>
      <li>It's important to have a strong data analysis and prioritize details on business analysis.</li>
      <li>You are able to analyze and solve problems including with quantitative data.</li>
      <li>It is preferred to run and operate queries using SQL</li>
      </ul>
      <br />
      So here you are, you will not be able to enjoy this work if you do not make this important step. What is that? Create your online portfolio and send it to us as soon as possible. Give your best potential and let's join the big family of Halo Jasa team.`,
    tag: 'Operational',
    icon: icOpe
  },
  {
    id: 28,
    title: 'Android Developer',
    url: 'android-dev',
    description: ``,
    requirement: `
      <b>So, what are the requirements?</b><br />

      <ul>
      <li>Willing to communicate well and cooperate with all team members.</li>
      <li>Has graduated from IT major from reputable university.</li>
      <li>Understand the service system with Android and related field.</li>
      <li>Understand and have expertise with Java and the Android SDK.</li>
      <li>Understand in MVP and / or MVVM</li>
      <li>Already experienced with developing, releasing, and maintaining Android Applications on top pf RESTful APIs.</li>
      <li>Willing to work with OO Design, data structures and problem solving.</li>
      <li>Ready to work with teams and assume that all jobs have an important role.</li>
      <li>If you have experience developing location-aware mobile applications, it will be priority.</li>
      </ul>
      <br />
      So here you are, you will not be able to enjoy this work if you do not make this important step. What is that? Create your online portfolio and send it to us as soon as possible. Give your best potential and let's join the big family of Halo Jasa team.
      `,
    tag: 'Technology',
    icon: icTech
  },
  {
    id: 29,
    title: 'Admin Operational',
    url: 'admin-operational',
    description: `
      <b>Acting as the Admin Operational for Halo Jasa, you will:</b><br /><br />

      As a large marketplace company, you will build customer trust to the company. You will greet each customer's need, good communicate in every time and negotiations with friendly for every problem.
      <br /><br />

      <b>What are your days like?</b><br /><br />

      Working as admin operational at Halo Jasa is so much fun, so you have to smile a lot when serving all the customers. You will always be in touch with customers directly or with social media. You will also be heavily involved with the work of system management and connect with many staff at Halo Jasa.
      <br /><br />
      

      <b>What can you say to your friends, about your work?</b><br /><br />   

      I serve many customers with different needs. I also work with a lot of staff at Halo Jasa and I am a person who is always ready to provide alternatives and solutions for customers. Yes, I am an admin operational at Halo Jasa team.
      <br /><br />
      

      <b>My responsibilities:</b><br />

      <ul>
      <li>I am ready to serve all orders from clients and staff.</li>
      <li>I am always provide solutions and good analysis for any service issues.</li>
      <li>I will quick to answer all customers questions by phone or social media.</li>
      <li>I will enjoy working with social media to always connect with customers.</li>
      <li>I can communicate well to Halo Jasa team and customers.</li>
      <li>I also have to doing all the administrative work.</li>
      </ul>
      `,
    requirement: `
      <b>So, what are the requirements?</b><br />

      <ul>
      <li>Always be able to communicate well over the phone.</li>
      <li>Have the power to provide an initial solution for every problem.</li>
      <li>Willing to use the Indonesian language according to EYD, both speak and write.</li>
      <li>Ready to work hard, including when to work with a shift schedule.</li>
      <li>Willing to do the job of administration, customer service and general affair.</li>
      <li>Not just working hard but also working smart with passion.</li>
      </ul>
      <br />
      So here you are, you will not be able to enjoy this work if you do not make this important step. What is that? Create your online portfolio and send it to us as soon as possible. Give your best potential and let's join the big family of Halo Jasa team.
      `,
    tag: 'Operational',
    icon: icOpe
  }
]

export default dataJobDetail
